import n, { useContext as s, useEffect as u } from "react";
import { PrimaryNavContext as l } from "./PrimaryNavContext";
import { TriggerIcon as c } from "./TriggerIcon";
import g from "clsx";

var y = function y() {
  var _s = s(l),
      t = _s.isBreakpointWithMenu,
      o = _s.activeFlyout,
      r = _s.setActiveFlyout,
      i = _s.setIsSubmenuOpen,
      e = _s.setIsAnimating,
      m = function m() {
    t && (o ? (e(!0), r(null), i(!1), document.documentElement.classList.remove("hg-primarynav--noscroll"), setTimeout(function () {
      e(!1);
    }, 240)) : (e(!0), r(function (a) {
      return a ? null : document.querySelector('[data-topnav-flyout="menu"]');
    }), document.documentElement.classList.add("hg-primarynav--noscroll"), setTimeout(function () {
      e(!1);
    }, 240)));
  };

  return u(function () {
    if (t) return function () {
      document.documentElement.classList.remove("hg-primarynav--noscroll");
    };
  }, [t]), n.createElement("div", {
    className: g("hg-primarynav__menutrigger")
  }, n.createElement("button", {
    className: "hg-primarynav__menutrigger-button",
    id: "hg-primarynav__menutrigger-button",
    "aria-controls": "hg-primarynav__list",
    "aria-label": "Menu",
    type: "button",
    onClick: m
  }, n.createElement(c, {
    svgPrefix: "mobile"
  })));
};

export { y as MenuTrigger };